import * as React from "react";
import Table from "../data/Table";
import { text } from "../data/fields/Fields";
import { StandardForm } from "../data/Editor";
import { FieldContext, MetaContext } from "../store/Context";
import { FormOption } from "../data/Types";
import { useDataSource } from "../data/Source";
import { Typography } from '@mui/joy';

function renderDecorator(row: any) {
    return row.name ? row.name.charAt(0) : '?';
}

function renderItem(row: any) {
    return (
        <div>
            <Typography fontWeight={600} sx={{ width: '100%' }} gutterBottom>
                {row.name}
            </Typography>
        </div>
    );
}

const metadata = {
    primary: 'id',
    table: 'owners',
    single: 'owner',
    zone: false,
    renderDecorator,
    renderItem,
    headers: [
        { title: 'Name', name: 'name' },
    ]
}

export function useOwnerOptions() {
    const { table, primary, zone } = metadata;
    const [options, setOptions] = React.useState<FormOption[] | null>(null);
    const listData = useDataSource(table, zone);
    React.useEffect(() => {
        if (!listData.isLoading) {
            setOptions(listData.items.map((item: any) => ({ 'id': item[primary], 'label': item['name'] })))
        }
    }, [listData.isLoading, listData.items, primary, setOptions])

    return options;
}
const fields = [
    text('Name', 'name', true),
];

export default function Owners() {
    return <MetaContext.Provider value={metadata}>
        <FieldContext.Provider value={fields}>
            <Table form={<StandardForm />} />
        </FieldContext.Provider>
    </MetaContext.Provider>
}